import { MouseEvent, useCallback, useState } from 'react';
import { useDismiss, useFloating, useInteractions } from '@floating-ui/react';

const useFloatingContextMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'bottom-start',
    strategy: 'fixed',
  });

  const dismiss = useDismiss(context, { ancestorScroll: true });
  const { getFloatingProps } = useInteractions([dismiss]);

  const handleOpen = useCallback(
    (event: MouseEvent) => {
      refs.setPositionReference({
        getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            x: event.clientX,
            y: event.clientY,
            top: event.clientY,
            left: event.clientX,
            right: event.clientX,
            bottom: event.clientY,
          };
        },
      });
      setIsOpen(true);
    },
    [refs],
  );

  const handleClose = useCallback(() => {
    refs.setPositionReference(null);
    setIsOpen(false);
  }, [refs]);

  return {
    isOpen,
    handleOpen,
    handleClose,
    setFloating: refs.setFloating,
    getFloatingProps,
    floatingStyles,
  };
};

export default useFloatingContextMenu;
